<template>
  <div class="discount-list">
    <div v-for="(item, index) in innerValue" :key="index" class="discount-card">
      <div class="discount-card__header">
        <span class="title">{{ couponTitle(index) }}</span>
        <span class="ops">
          <el-button v-if="index !== 0" type="text" @click="remove(index)">
            <i class="el-icon-delete"></i>
            {{ $tx('common.delete', '删除') }}
          </el-button>
        </span>
      </div>

      <div class="wheel-setting-item">
        <p class="wheel-setting-field">{{ $tx('form.edit.field.couponPrompt', 'Coupon提示') }}</p>
        <el-input
          v-model="item.couponPrompt"
          @change="emitChange"
          placeholder="Your discount code is"
          autosize
          class="class-input"
          show-word-limit
          maxlength="60"
        />
      </div>

      <div class="wheel-setting-item">
        <p class="wheel-setting-field">{{ $tx('form.discount.title', '折扣码设置') }}</p>
        <div class="el-form-item wheel-setting-item col-10" style="margin: 0;">
          <el-select v-model="item.discountType" @change="emitChange" :placeholder="$tx('common.pleaseSelect', '请选择')">
            <span v-if="item.discountType === 'dongtai'" slot="prefix" style="padding-left: 2px; font-size: 18px; height: 100%; display: inline-flex; align-items: center;">
              <el-tooltip class="item" popper-class="discount-pop" effect="light" :content="$tx('form.edit.field.uniqueCouponTip', '我们将为弹窗中coupon获得者发放唯一折扣码,该折扣码将在下单时自动应用')" placement="bottom-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
            <el-option
              v-for="opt in selectOptions"
              :key="opt.value"
              :label="opt.i18nKey ? $tx(opt.i18nKey, opt.name) : opt.name"
              :value="opt.value"
            >
              <div>
                <span
                  v-if="opt.value === 'dongtai'"
                  style="padding-left: 2px; color: #C5C4CE; font-size: 18px; height: 100%; display: inline-flex; align-items: center; vertical-align: text-top;"
                >
                  <el-tooltip class="item" popper-class="discount-pop" effect="light" :content="$tx('form.edit.field.uniqueCouponTip', '我们将为弹窗中coupon获得者发放唯一折扣码,该折扣码将在下单时自动应用')" placement="bottom-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                {{ opt.i18nKey ? $tx(opt.i18nKey, opt.name) : opt.name }}
              </div>
            </el-option>
          </el-select>
        </div>
      </div>

      <div v-if="item.discountType === 'dongtai'" class="wheel-setting-item col-10">
        <el-button type="text" @click="$emit('set-dynamic', index)">{{ $tx('form.edit.field.setCoupon', '设置折扣码') }}<i class="el-icon-arrow-right"></i></el-button>
      </div>

      <div v-if="item.discountType === 'guding'" class="wheel-setting-item">
        <p class="wheel-setting-field">{{ $tx('form.edit.field.couponCode', '折扣码') }}</p>
        <div class="el-form-item wheel-setting-item" :class="item.couponCode ? '' : 'is-error'">
          <el-input
            class="wheel-setting-collapse-input-coupon class-input"
            v-model="item.couponCode"
            @change="emitChange"
            maxlength="30"
            show-word-limit
            autosize
            placeholder="coupon code"
          />
        </div>
      </div>

      <div v-if="enableCouponSize" class="wheel-setting-item">
        <p class="wheel-setting-field">
          {{ $tx('form.edit.field.discountValue', '折扣值') }}
          <info-popover
            :lines="discountValueTip"
            placement="top"
            icon-style="margin-left: 4px; cursor: pointer; vertical-align: middle; margin-top: -4px;"
          />
        </p>
        <el-input
          v-model="item.couponSize"
          @change="emitChange"
          maxlength="40"
          show-word-limit
          autosize
          class="class-input"
          :placeholder="$tx('form.edit.field.enterDiscount', '请输入折扣值')"
        />
      </div>
    </div>

    <div v-if="innerValue.length < max" class="discount-add">
      <el-button type="text" @click="add">
        <i class="el-icon-plus"></i>
        {{ $tx('form.discount.addCoupon', '添加折扣券') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import InfoPopover from '@/views/wheelOfFortune/components/InfoPopover.vue';
import { isEnableCouponSize } from '@/utils/isEnableCouponSize';

export default {
  name: 'DiscountList',
  components: {
    'info-popover': InfoPopover
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 20
    },
    templateId: {
      type: [String, Number],
      default: ''
    },
    triggerEventType: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      innerValue: []
    }
  },
  computed: {
    discountValueTip() {
      return [this.$tx('form.discount.valueTip', '折扣值不在订阅工具用户侧展示，仅用于邮件变量。若邮件已勾选「优先使用用户之前通过订阅工具获取过的 Coupon Code 对应的折扣值」，请填写与折扣码对应的显示内容（如 15%）。')];
    },
    enableCouponSize() {
      // 折扣值能力需要走公司灰度，并排除单步骤模板
      return isEnableCouponSize(this.templateId)
    },
    selectOptions() {
      const base = [{ name: this.$tx('form.edit.field.staticCoupon', '固定折扣码'), value: 'guding', i18nKey: 'form.edit.field.staticCoupon' }]
      return base
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(v) {
        // 避免循环更新：只在数据真正不同时更新
        const newData = (v || []).map(it => ({
          couponPrompt: it.couponPrompt || '',
          discountType: it.discountType || 'guding',
          couponCode: it.couponCode || '',
          couponSize: this.enableCouponSize ? (it.couponSize || '') : ''
        }))
        
        // 比较新旧数据是否真的不同
        if (JSON.stringify(newData) !== JSON.stringify(this.innerValue)) {
          this.innerValue = newData
        }
      }
    }
  },
  mounted() {
    // Component mounted
  },
  methods: {
    couponTitle(index) {
      return this.$tx('form.discount.couponN', '折扣券{{index}}', { index: index + 1 })
    },
    add() {
      if (this.innerValue.length >= this.max) return
      this.innerValue.push({
        couponPrompt: '',
        discountType: 'guding',
        couponCode: '',
        couponSize: ''
      })
      this.emitChange()
    },
    remove(i) {
      this.innerValue.splice(i, 1)
      this.emitChange()
    },
    emitChange() {
      const value = this.innerValue.map(it => ({
        ...it,
        couponSize: this.enableCouponSize ? (it.couponSize || '') : ''
      }))
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
.discount-card {
  border: 1px solid #E4E3EB;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;
  padding: 0 12px;
}
.discount-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F6F5FF;
  height: 45px;
  line-height: 45px;
  padding: 0 12px;
  margin: 0 -12px 12px;
}
.discount-card__header .title {
  color: #5a54f9;
  font-weight: 600;
}
.discount-add {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}
.limit-tip { color: #C5C4CE; }
</style>
